import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'antd';
import { Icon as CroplerIcon, Button } from '@cropler/ui-kit';
import stylesDropdownMenu from '../../styles/dropdownMenu.module.scss';

import { Languages } from '../../i18n/constants';
import { catalogApi } from '../../store/api/catalog';

const LocalizationSelect = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const currentLangLabel = Languages.find((obj) => obj.key === currentLang)?.label;
  const dispatch = useDispatch();

  const items = Languages.map((obj) => {
    if (obj.key !== currentLang) {
      return {
        label: (
          <div className={`${stylesDropdownMenu.dropdownMenuItem}`}>
            <Button
              className={stylesDropdownMenu.dropdownMenuBtn}
              size={'large'}
              type="text"
              onClick={() => onClickLang({ key: obj.key })}
            >
              {obj.label}
            </Button>
          </div>
        ),
        key: obj.id,
      };
    }
  });

  const onClickLang = ({ key }) => {
    i18n.changeLanguage(key).catch((error) => {
      console.error('Failed to change language:', error);
    });
    // Translate crops list
    dispatch(catalogApi.util.resetApiState());
  };

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <span>
        <Button type="secondary" className={stylesDropdownMenu.dropdownMenuToggle} size={'large'}>
          <span className={stylesDropdownMenu.dropdownMenuToggleText}>{currentLangLabel || 'English'}</span>
          <CroplerIcon name="down" />
        </Button>
      </span>
    </Dropdown>
  );
};

export default LocalizationSelect;
